/**
 * connected-react-routerを使用したルーティングに関するStateを扱うモジュール
 */
import { createBrowserHistory } from 'history';
import { connectRouter } from 'connected-react-router';

const basename = '';

export const history = createBrowserHistory({
  basename
});

export default connectRouter(history);
